import React, { Suspense } from "react";
import { CircularProgress, Box } from "@mui/material";
import { Route } from "react-router-dom";
import {ApplicationContainer, ClientMediator} from "@8d-xyz/ui-react_application_f-container"

export function lazyWithFallback(importFn, fallbackImportFn) {
    return React.lazy(async () => {
      try {
        return await importFn();
      } catch (err) {
        console.warn("Component load failed. Falling back to Splash.jsx", err);
        return await fallbackImportFn();
      }
    });
  }

  export function generateLazyRoutes(routeConfig, importPathFn, fallbackPathFn) {
    return routeConfig.map(({ PATH, PAGE }, index) => {
      const LazyComponent = lazyWithFallback(
        () => importPathFn(PAGE),
        fallbackPathFn
      );
   
      
    return (
      <Route
        key={index}
        path={PATH}
        element={
          <Suspense
            fallback={
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100vh"
              >
                <CircularProgress />
              </Box>
            }
          >
            <ApplicationContainer context={<LazyComponent />} />
          </Suspense>
        }
      />
    );
  });
  }